<template>
  <v-dialog persistent v-model="approvePenaltyModal" width="700">
    <v-card>
      <v-card-title class="headline blue darken-3 white--text" default-title>
        Acknowledge Penalty Request
      </v-card-title>

      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <form-error-display-handler :errors="errors"/>
            <v-flex xs12>
              <v-form ref="approvePenaltyForm" v-model="valid" lazy-validation class="px-2">
                <v-textarea
                    label="Remarks *"
                    :rules="[rules.required]"
                    outlined
                    v-model="approvePenaltyForm.remarks"
                />
                <!--                <multiple-file-upload-->
                <!--                    label="Upload documents (if any)"-->
                <!--                    v-model="approvePenaltyForm.files"-->
                <!--                />-->
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="red lighten-1" class="white--text" @click="closeModal">Close</v-btn>
        <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="approvePenalty">Acknowledge</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from "vuex";
import {validationMixin} from "../../mixins/validationMixin";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import FileInput from "../FileInput";
import MultipleFileUpload from "../MultipleFileUpload";

export default {
  data: () => ({
    valid: true,
    approvePenaltyForm: {},
    errors: [],
    loading: false
  }),
  components: {
    FormErrorDisplayHandler,
    FileInput,
    MultipleFileUpload
  },
  mixins: [validationMixin],
  computed: {
    approvePenaltyModal: {
      get() {
        return this.$store.state.VisaRequestSingle.acknowledgePenaltyModal;
      },
      set(value) {
        this.$store.commit("VisaRequestSingle/setAcknowledgePenaltyModal", value);
      }
    },
  },
  methods: {
    ...mapActions("VisaRequestSingle", ["acknowledgePenaltyRequest", "getVisaRequestDetail"]),
    approvePenalty() {
      if (this.$refs.approvePenaltyForm.validate()) {
        let formData = new FormData();
        formData.set('remarks', this.approvePenaltyForm.remarks);
        // formData.set('file', this.approvePenaltyForm.file);
        let files = this.approvePenaltyForm.files;
        if (files !== undefined) {
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }

        this.loading = true;
        this.acknowledgePenaltyRequest(formData)
            .then(res => {
              this.form = false;
              this.approvePenaltyForm = {};
              this.errors = null;
              this.approvePenaltyModal = false;
              this.$store.commit("Notification/showSuccess", 'Visa penalty acknowledged!');
            })
            .catch(error => {
              console.log('erro', error.response.data)
              if (error.response.status === 422 || error.response.status === 400) {
                if (error.response.data.message) {
                  this.$store.commit("Notification/showError", error.response.data.message);
                }
                this.errors = error.response.data.errors;
              }
            }).finally(() => {
          this.loading = false;
        });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    },
    closeModal() {
      this.approvePenaltyModal = false;
      this.approvePenaltyForm = false
    }
  }
};
</script>
